// Invoice.js
import React from 'react';
import classes from './GenerateBill.module.css';
import { useLocation } from "react-router-dom";
import { QRCodeSVG } from 'qrcode.react';
import logo from "../../Asset/ogsw-full.png";
import OgsLogos from '../../Asset/ogsw-full.png';

const GenerateBill = () => {
  const items = Array(2).fill({ name: 'Item goes here', price: 100, qty: 2 });
  const subtotal = items.reduce((acc, item) => acc + item.price * item.qty, 0);
  const tax = 0;
  const total = subtotal + tax;
  const location = useLocation();
  const { InvoicesData} = location.state || {};
 
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0');       
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();                            

    return `${day}/${month}/${year}`;
  };

  return (
    <div className={classes.invoiceWrapper}>
      <div className={classes.invoiceContainer}>
        {/* <div className={classes.invoiceTop}> */}
        <div className={classes.invoiceTopBar} />
        <div className={classes.logoArea}>
          <img src={logo} alt="Olarms Logo" className={classes.logoimage} />
        

        </div>
       
        <header className={classes.invoiceHeader}>
          <div className={classes.leftHeader}>

            {/* <div className={classes.invoiceTitle}>Invoice</div> */}
            <p className={classes.invoiceNumber}>INVOICE TO: </p>
            <p className={classes.invoiceNumber2}>{InvoicesData?.customer?.name}</p>
            <p className={classes.invoiceAddress}>
              {InvoicesData?.customer?.address
                ? InvoicesData.customer.address
                  .toLowerCase()
                  .split(' ')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ')
                : ''}
            </p>

            {/* <p className={classes.invoiceDate}>{message?.data?.created_at ? formatDate(message?.data?.created_at) : 'N/A'} </p> */}
          </div>




          <QRCodeSVG value="https://example.com" />


          <div className={classes.rightHeader}>
            <p className={classes.invNo}>Account No.: {InvoicesData?.customer?.account_number}</p>
            <p className={classes.invNo}>Invoice No.: {InvoicesData?.bill_number}</p>
            {/* <p className={classes.invNo}>Invoice Date: {new Date(InvoicesData?.customer.created_at).toLocaleDateString()}</p> */}
            <p className={classes.invNo}>Due Date: {InvoicesData?.due_date}</p>

            {/* <p className={classes.invoiceDate}>{message?.data?.created_at ? formatDate(message?.data?.created_at) : 'N/A'} </p> */}
            {/* <QRCodeSVG value="https://example.com" /> */}

          </div>
        </header>

        <table className={classes.invoiceTable}>
          <thead>
            <tr style={{}}>
              <th >Description</th>
              <th></th>
              <th></th>
              <th></th>
              {/* <th>BILL TYPE</th> */}
              <th style={{ textAlign: 'right', }}>Amount</th>
              {/* <th>TOTAL</th> */}
            </tr>
          </thead>
          <tbody>
            {/* {items.map((item, index) => ( */}
            {/* <tr key={index}> */}
            <tr>
              <td style={{ width: 400, fontSize: 15, fontWeight: 600 }}>{InvoicesData?.description}</td>
              <td></td>
              <td></td>
              <td></td>
              <td style={{ textAlign: 'right', fontSize: 15, fontWeight: 600 }}>#{parseFloat(InvoicesData?.amount).toLocaleString(
                "en-US",
                {
                  minimumIntegerDigits: 1,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}</td>
              {/* <td>€{(item.price * item.qty).toFixed(2)}</td> */}
            </tr>
            {/* ))} */}
          </tbody>
        </table>

        <div className={classes.infwrap}>
          <div className={classes.paymentInfo}>
            <p className={classes.invoiceNumber} style={{ color: '#1963d2' }}>
              PAYMENT INFORMATION:
            </p>

            <div className={classes.infoRow}>
              <span className={classes.label}>Account No.:</span>
              <span className={classes.value}>{InvoicesData?.account_number}</span>
            </div>

            <div className={classes.infoRow}>
              <span className={classes.label}>Bank Name:</span>
              <span className={classes.value}>{InvoicesData?.bank_name}</span>
            </div>
          </div>


          <div className={classes.summaryBox}>
            {/* <div className={classes.summaryRow}><span>SUBTOTAL</span><span>€{subtotal.toFixed(2)}</span></div> */}
            {/* <div className={classes.summaryRow}><span>TAX</span><span>€{tax.toFixed(2)}</span></div> */}
            <div className={classes.totalRow}><span>TOTAL</span><span> #{parseFloat(InvoicesData?.amount).toLocaleString(
              "en-US",
              {
                minimumIntegerDigits: 1,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )}</span></div>
          </div>
        </div>
        <div className={classes.noticetexta} 
        // style={{ pageBreakBefore: 'always', breakBefore: 'page' }}
        >
          <h4>STEPS TO MAKE YOUR PAYMENT</h4>
        </div>
        <div className={classes.btmCards}>
          <div className={classes.noticetext}>
            <h4>USING BANK TRANSFER</h4>
          </div>
          <div className={classes.noticetexts}>
            <h4>BANK BRANCH (for Bank Tellers)</h4>
          </div>
        </div>
        <div className={classes.btmCards}>
          <div className={classes.noticetext}>
            <ul>
              <li>Open your banking app or log in to internet banking</li>
              <li>Use your credentials (PIN, fingerprint, password, or token).</li>
              <li>Select <span style={{fontWeight: 700}}>“Transfer” or “Send Money” </span> option</li>
              <li>Select <span style={{fontWeight: 700}}>{InvoicesData?.bank_name}</span> from the list.</li>
              <li>Input <span style={{fontWeight: 700}}>{InvoicesData?.account_number}</span> as the Account Number.</li>
              <li>The system will display <span style={{fontWeight: 700}}>"Ogun State Water Corporation" as the Account Name.</span></li>
              <li>Enter <span style={{fontWeight: 700}}>{parseFloat(InvoicesData?.amount).toLocaleString(
                "en-US",
                {
                  minimumIntegerDigits: 1,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}</span> as the transfer amount</li>
              <li>Click on "Make Payment" and continue the process</li>
            </ul>
          </div>
          <div className={classes.noticetexts}>
            <ul>
              <li>Visit any <span style={{fontWeight: 700}}>{InvoicesData?.bank_name}</span> branch close to you.</li>
              <li>Request a transfer form and fill in <span style={{fontWeight: 700}}>"Ogun State Water Corporation"</span> as the Account Name and <span style={{fontWeight: 700}}>{InvoicesData?.account_number}</span> as the
                Account Number
              </li>
              <li>Submit the form to a Cashier with the sum of <span style={{fontWeight: 700}}>{parseFloat(InvoicesData?.amount).toLocaleString(
                "en-US",
                {
                  minimumIntegerDigits: 1,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}</span> Naira only</li>
              <li>Collect your transaction slip</li>
            </ul>
          </div>
        </div>


        <footer className={classes.footer}>
          <span>Ibrahim Babangida Boulevard, Oke-Mosan, Abeokuta, P.M.B 2074</span>
          <span>081 3494 1730</span>
          <span>info@ogswc.ogunstate.gov.ng</span>
          {/* <span>www.science.com</span> */}

        </footer>
      </div>
    </div>
  );
};

export default GenerateBill;
